module.exports = __webpack_public_path__ + "static/media/AI1.98e33ad1.jpeg";